import { Checkbox, Descriptions, Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import svg27 from "../../../assets/svg/svg27.svg";
import InsideHeader from "../../../components/InsideHeader";
import svg38 from "../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import { fetchStaffNetPays } from "../../../features/dropdown/dropdownSlice";
import { formatMoney, numberWithCommas } from "../../../utils";
import FilterModalStaff from "./FilterModalStaff";
import withdrawal from "../../../assets/svg/withdrawalSvg.svg";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import ConfirmSubmitModal from "../../../components/ConfirmSubmitModal";
import OtpModal from "./OtpModal";
import CardLoading from "../../../components/CardLoading";
import svg56 from "../../../assets/svg/svg56.svg";
import svg66 from "../../../assets/svg/svg66.svg";
import verifiedPng from "../../../assets/img/verified.png";

export default function StaffNetTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { staffNetPays, loading, staffNetPaysCount } = useSelector(
    (state) => state.dropdown
  );
  const { staffObj } = useSelector((state) => state.folder);
  const { saving } = useSelector((state) => state.save);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchStaffNetPays());
    await setFilters([]);
  };

  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);
  const [isModalOpenSubmitVerify, setIsModalOpenSubmitVerify] = useState(false);

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const [openOtp, setopenOtp] = useState(false);
  async function handleCancelOtp() {
    await setopenOtp(false);
    await setIsModalOpenSubmit(true);
  }

  async function handleOpenOtp() {
    const res = await dispatch(
      save({
        url: `py/sendOtp.action`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setopenOtp(true);
      await setIsModalOpenSubmit(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }

  const handleConfirmation = async () => {
    await setIsModalOpenSubmit(true);
  };

  async function handleOpenVerify() {
    await setIsModalOpenSubmitVerify(true);
  }

  const handleSubmit = async () => {
    const res = await dispatch(
      save({
        url: `py/disbursePayrollPayment.action?fpYear=${staffObj?.fpPyear}&fpMonth=${staffObj?.fpPmonth}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setopenOtp(false);
      await setIsModalOpenSubmit(false);
      await navigate("/payroll-payments");
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  console.log("staffObj", staffObj);

  const handleExport = () => {};

  const handleView = () => {};

  const columns = [
    {
      title: "Personnel #",
      dataIndex: "ppPfno",
      sorter: (a, b) => a.ppPfno.localeCompare(b.ppPfno),
    },
    {
      title: "Personnel Name",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
    },
    {
      title: "Type",
      dataIndex: "itemname",
      sorter: (a, b) => a.itemname.localeCompare(b.itemname),
    },
    {
      title: "Year",
      dataIndex: "fpPyear",
      sorter: (a, b) => a.fpPyear - b.fpPyear,
    },
    {
      title: "Month",
      dataIndex: "fpPmonth",
      sorter: (a, b) => a.fpPmonth - b.fpPmonth,
    },
    {
      title: "Amount",
      dataIndex: "ptAmount",
      sorter: (a, b) => a.ptAmount - b.ptAmount,
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
    },
    {
      title: "Bank Name",
      dataIndex: "bankBranchName",
      sorter: (a, b) => a.bankBranchName.localeCompare(b.bankBranchName),
    },
    {
      title: "Account No",
      dataIndex: "accountNo",
      sorter: (a, b) => a.accountNo - b.accountNo,
    },
    {
      title: "Number Verification",
      dataIndex: "isReceiverNumberVerified",
      render: (item) => {
        return (
          <div>
            {item == null || item == false ? (
              <Checkbox checked={false}></Checkbox>
            ) : item == true ? (
              <Checkbox checked={true}></Checkbox>
            ) : null}
          </div>
        );
      },
      sorter: (a, b) =>
        a.isReceiverNumberVerified.localeCompare(b.isReceiverNumberVerified),
    },
    {
      title: "Verified Receiver Name",
      dataIndex: "verifiedReceiverName",
      sorter: (a, b) =>
        a.verifiedReceiverName.localeCompare(b.verifiedReceiverName),
    },

    {
      title: "Status",
      dataIndex: "pdStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING_PAYMENT"
                ? "bg-[#FFB74D]"
                : item === "FAILED"
                ? "bg-[#FF4D4F]"
                : item === "PROCESSING"
                ? "bg-[#FFC107]"
                : item === "COMPLETED"
                ? "bg-darkGreen"
                : null
            }  text-[#FFf] font-[700] inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },
    {
      title: "Ndovupay Status",
      dataIndex: "pdNdovupayStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING_PAYMENT"
                ? "bg-[#FFB74D]"
                : item === "FAILED"
                ? "bg-[#FF4D4F]"
                : item === "PROCESSING"
                ? "bg-[#FFC107]"
                : item === "COMPLETED"
                ? "bg-darkGreen"
                : item === "QUEUED"
                ? "bg-[#90CAF9]"
                : null
            }  text-[#FFf] font-[700] inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchStaffNetPaysData(page, size) {
    dispatch(
      fetchStaffNetPays({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        fpYear: staffObj?.fpPyear,
        fpMonth: staffObj?.fpPmonth,
      })
    );
  }

  const items = [
    {
      key: "1",
      label: "Year",
      children: staffObj?.fpPyear,
    },
    {
      key: "2",
      label: "Month",
      children: staffObj?.fpPmonth,
    },

    {
      key: "3",
      label: "Total Net Amount",
      children: <div>{formatMoney(staffObj?.totalNetAmount)}</div>,
    },
    {
      key: "4",
      label: "Status",
      children:
        staffObj?.fpPaymentStatus === null
          ? "PENDING PAYMENT"
          : staffObj?.fpPaymentStatus,
    },
  ];
  const settingItemsQuickActions = [
    {
      key: "1",
      label: (
        <Link
          onClick={
            staffObj?.fpPaymentStatus === "COMPLETED"
              ? null
              : handleConfirmation
          }
          className={`${
            staffObj?.fpPaymentStatus === "COMPLETED"
              ? "cursor-not-allowed"
              : "cursor-pointer"
          } flex  text-[16px] font-sans  !text-lightBlack py-1`}
        >
          {staffObj?.fpPaymentStatus === "COMPLETED"
            ? "Already Disbursed"
            : " Disburse Payment"}
        </Link>
      ),
    },

    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenVerify}
          className="flex  text-[16px] font-sans  !text-lightBlack py-1"
        >
          Verify Accounts
        </Link>
      ),
    },
  ];

  async function handleVerifyAcnts() {
    const res = await dispatch(
      save({
        url: `py/verifyPayrollAccounts.action?fpYear=${staffObj?.fpPyear}&fpMonth=${staffObj?.fpPmonth}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setopenOtp(false);
      await setIsModalOpenSubmit(false);
      await navigate("/staff-net");
      await fetchStaffNetPaysData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  }
  useEffect(() => {
    fetchStaffNetPaysData();
  }, []);

  if (loading) return <CardLoading />;

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Staff Net Amount Information"
        subtitle="Manage Staff Net Amount within your institution"
        back={true}
        title1="Payroll Payments"
        title2="Staff  Net Amount"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={2}
              colon={false}
              title="Fiscal Period Information"
              items={items}
            />
          </div>
          <div className="flex justify-between items-center">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Staff Net Amount Details
            </h3>
            <div className="w-[300px] flex justify-end">
              <Dropdown
                overlayStyle={{
                  width: "250px",
                }}
                trigger={"click"}
                menu={{ items: settingItemsQuickActions }}
                placement="bottom"
              >
                <div className="w-[200px]">
                  <button className="cstm-btn flex gap-x-2" type="submit">
                    <img src={svg56} alt={svg56} /> Quick actions
                  </button>
                </div>
              </Dropdown>

              {/* <button
                key="submit"
                type="submit"
                className={`${
                  staffObj?.fpPaymentStatus === "COMPLETED"
                    ? "cursor-not-allowed"
                    : "cursor-pointer"
                } cstm-btn flex items-center gap-x-2 !rounded-[10px]`}
                style={{ boxShadow: "0 4px 0 0 #2A662C" }}
                onClick={
                  staffObj?.fpPaymentStatus === "COMPLETED"
                    ? null
                    : handleConfirmation
                }
              >
                <img src={withdrawal} alt="withdrawal" />
                {staffObj?.fpPaymentStatus === "COMPLETED"
                  ? "Already Paid"
                  : "Initiate Ndovupay Payment"}
              </button> */}
            </div>
          </div>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <span>
                {" "}
                <button
                  onClick={showModalFilter}
                  type="button"
                  className={`bg-transparent flex items-center gap-x-'1' ${
                    Object?.keys(formData)?.length > 0
                      ? "!text-[#5688E5]"
                      : "inherit"
                  }`}
                >
                  <MaterialIcon color="#141414" icon="filter_list" />
                  Filters
                </button>
              </span>
              {Object?.keys(formData)?.length > 0 && (
                <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                  :{Object?.keys(formData)?.length}
                  <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                </span>
              )}
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.ptId}
                columns={columns}
                dataSource={staffNetPays}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: staffNetPaysCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchStaffNetPaysData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <FilterModalStaff
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
        year={staffObj?.fpPyear}
        month={staffObj?.fpPmonth}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={handleOpenOtp}
        loading={saving}
        content={`Are you sure you want to disburse payroll payments for  ${staffObj?.fpPyear}`}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmitVerify}
        setIsModalOpen={setIsModalOpenSubmitVerify}
        handleSubmit={handleVerifyAcnts}
        loading={saving}
        content={`Are you sure you want to verify account details for ${staffObj?.fpPyear} `}
      />

      <OtpModal
        title={`Verify your transaction for ${staffObj?.fpPyear}`}
        open={openOtp}
        handleCancel={handleCancelOtp}
        handleSubmit={handleSubmit}
      />
    </div>
  );
}
